import { useQuery, useMutation } from '@tanstack/react-query';
import api from '../utils/api';

// Single sign-on hand-off to another dropzone host.
//
// These live under /api/auth, not /api/group, because every host in the group
// issues hand-offs — the fields as much as the group host. A field carries no
// group console and no /api/group router at all.
//
// Issue is owner-only on the backend. An admin — who also sees the switcher —
// gets a 403, which is a legitimate answer: the caller falls back to plain
// navigation and they sign in with a password at the other field.

export function useSsoStatus({ enabled = true } = {}) {
  return useQuery({
    queryKey: ['auth', 'sso-status'],
    queryFn: async () => (await api.get('/auth/sso/status')).data.data,
    enabled,
    retry: false,
    staleTime: 10 * 60 * 1000,
  });
}

export function useSsoHandoff() {
  return useMutation({
    mutationFn: async (dropzone) =>
      (await api.post('/auth/sso/issue', { dropzone })).data.data,
  });
}
